import { render, staticRenderFns } from "./systemSettings.vue?vue&type=template&id=2f2dfd62&scoped=true"
import script from "./systemSettings.vue?vue&type=script&lang=js"
export * from "./systemSettings.vue?vue&type=script&lang=js"
import style0 from "./systemSettings.vue?vue&type=style&index=0&id=2f2dfd62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2dfd62",
  null
  
)

export default component.exports